import { Plugin } from '@uppy/core';
import settle from '@uppy/utils/lib/settle';

class UppyGraphQl extends Plugin {
  constructor(uppy, opts) {
    super(uppy, opts);
    this.id = opts.id || 'GraphQl';
    this.type = 'uploader';

    this.handleUpload = this.handleUpload.bind(this);
    this.uploadFiles = this.uploadFiles.bind(this);
  }

  uploadFiles(files) {
    let variables = this.opts.variables;
    variables.files = files.map(file => file.data);

    return settle([this.opts.schema({ variables: variables })]);
  }

  async handleUpload(fileIDs) {
    if (fileIDs.length === 0) {
      this.uppy.log('[GraphQl] No files to upload');

      return Promise.resolve();
    }

    if (!this.opts.schema) {
      this.uppy.log('[GraphQl] No graphQl schema');

      return Promise.resolve();
    }

    this.uppy.log('[GraphQl] Uploading...');
    const filesToUpload = fileIDs.map(fileID => this.uppy.getFile(fileID));

    fileIDs.forEach(fileID => {
      const file = this.uppy.getFile(fileID);
      this.uppy.emit('preprocess-progress', file, {
        mode: 'indeterminate',
        message: 'Téléversement en cours',
      });
    });

    const upload = await this.uploadFiles(filesToUpload);

    if (upload?.successful.length > 0) {
      this.uppy.emit('upload-success', upload.successful[0].data);
    }

    return upload;
  }

  install() {
    this.uppy.setState({
      capabilities: Object.assign({}, this.uppy.getState().capabilities, {
        resumableUploads: true,
      }),
    });
    this.uppy.addUploader(this.handleUpload);
  }

  uninstall() {
    this.uppy.setState({
      capabilities: Object.assign({}, this.uppy.getState().capabilities, {
        resumableUploads: false,
      }),
    });
    this.uppy.removeUploader(this.handleUpload);
  }
}

export default UppyGraphQl;
